import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Login from './pages/Login';
import Home from './pages/Home';
import Layout from './components/Layout';
import AdminHubPage from './pages/AdminHubPage';
import ProductionHubPage from './pages/ProductionHubPage';
import SettingsPage from './pages/SettingsPage';
import CompaniesPage from './pages/CompaniesPage';
import FarmsPage from './pages/FarmsPage';
import BunchSleeversPage from './pages/BunchSleeversPage';
import RibbonsPage from './pages/RibbonsPage';
import SleeverControlPage from './pages/SleeverControlPage';
import SleeverControlListPage from './pages/SleeverControlListPage';
import ProductionSummaryPage from './pages/ProductionSummaryPage';
import BudgetPage from './pages/BudgetPage';
import FumigationPage from './pages/FumigationPage';
import FumigationHistoryPage from './pages/FumigationHistoryPage';
import UsersPage from './pages/UsersPage';
import NovedadesPage from './pages/NovedadesPage';
import VentasPage from './pages/VentasPage';
import DespachosPage from './pages/DespachosPage';
import RemisionFormPage from './pages/RemisionFormPage';
import RemisionHistoryPage from './pages/RemisionHistoryPage';
import HarvestFormPage from './pages/HarvestFormPage';
import HarvestHistoryPage from './pages/HarvestHistoryPage';
import RecobroPage from './pages/RecobroPage';
import SalesFormPage from './pages/SalesFormPage';
import SalesHistoryPage from './pages/SalesHistoryPage';
import SalesSummaryPage from './pages/SalesSummaryPage';
import {
  BoxTypesPage, BrandsPage, DestinationsPage, DriversPage, ExportersPage, FumigationCompaniesPage,
  FumigationPilotsPage, FumigationProductsPage, InspectorsPage, TransportationsPage,
} from './pages/catalogPages';
import ProfilePage from './pages/ProfilePage';
import ProtectedRoute from './components/ProtectedRoute';
import { ADMIN_PERMISSION_KEYS, PRODUCTION_PERMISSION_KEYS } from './permissions';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route path="/" element={
            <ProtectedRoute>
              <Layout><Home /></Layout>
            </ProtectedRoute>
          } />

          {/* Not /admin: on the server that address belongs to Django's own admin (nginx sends
              /admin/ there), so opening it in a new window or refreshing would leave the app. */}
          <Route path="/administration" element={
            <ProtectedRoute requirePermission={ADMIN_PERMISSION_KEYS}>
              <Layout><AdminHubPage /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/admin" element={<Navigate to="/administration" replace />} />

          <Route path="/settings" element={
            <ProtectedRoute requirePermission="admin_settings">
              <Layout><SettingsPage /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/companies" element={
            <ProtectedRoute requirePermission="admin_companies">
              <Layout><CompaniesPage /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/farms" element={
            <ProtectedRoute requirePermission="admin_farms">
              <Layout><FarmsPage /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/bunch-sleevers" element={
            <ProtectedRoute requirePermission="admin_bunch_sleevers">
              <Layout><BunchSleeversPage /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/ribbons" element={
            <ProtectedRoute requirePermission="admin_ribbons">
              <Layout><RibbonsPage /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/exporters" element={
            <ProtectedRoute requirePermission="admin_exporters">
              <Layout><ExportersPage /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/fumigation-companies" element={
            <ProtectedRoute requirePermission="admin_fumigation_companies">
              <Layout><FumigationCompaniesPage /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/fumigation-pilots" element={
            <ProtectedRoute requirePermission="admin_fumigation_pilots">
              <Layout><FumigationPilotsPage /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/fumigation-products" element={
            <ProtectedRoute requirePermission="admin_fumigation_products">
              <Layout><FumigationProductsPage /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/brands" element={
            <ProtectedRoute requirePermission="admin_brands">
              <Layout><BrandsPage /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/transportations" element={
            <ProtectedRoute requirePermission="admin_transportations">
              <Layout><TransportationsPage /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/destinations" element={
            <ProtectedRoute requirePermission="admin_destinations">
              <Layout><DestinationsPage /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/drivers" element={
            <ProtectedRoute requirePermission="admin_drivers">
              <Layout><DriversPage /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/box-types" element={
            <ProtectedRoute requirePermission="admin_box_types">
              <Layout><BoxTypesPage /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/inspectors" element={
            <ProtectedRoute requirePermission="admin_inspectors">
              <Layout><InspectorsPage /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/production" element={
            <ProtectedRoute requirePermission={PRODUCTION_PERMISSION_KEYS}>
              <Layout><ProductionHubPage /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/enfunde" element={
            <ProtectedRoute requirePermission="production">
              <Layout><SleeverControlPage /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/enfunde/list" element={
            <ProtectedRoute requirePermission="production">
              <Layout><SleeverControlListPage /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/production-summary" element={
            <ProtectedRoute requirePermission="production_summary">
              <Layout><ProductionSummaryPage /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/fumigacion" element={
            <ProtectedRoute requirePermission="fumigation">
              <Layout><FumigationPage /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/fumigacion/historial" element={
            <ProtectedRoute requirePermission="fumigation">
              <Layout><FumigationHistoryPage /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/fumigacion/:id" element={
            <ProtectedRoute requirePermission="fumigation">
              <Layout><FumigationPage /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/production-budget" element={
            <ProtectedRoute requirePermission="production_budget">
              <Layout><BudgetPage /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/recobro" element={
            <ProtectedRoute requirePermission="recobro">
              <Layout><RecobroPage /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/cosecha" element={
            <ProtectedRoute requirePermission="harvest">
              <Layout><HarvestFormPage key="new" /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/cosecha/historial" element={
            <ProtectedRoute requirePermission="harvest">
              <Layout><HarvestHistoryPage /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/cosecha/:id" element={
            <ProtectedRoute requirePermission="harvest">
              <Layout><HarvestFormPage key="edit" /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/ventas" element={
            <ProtectedRoute requirePermission="ventas">
              <Layout><VentasPage /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/ventas/formulario" element={
            <ProtectedRoute requirePermission="ventas">
              <Layout><SalesFormPage key="new" /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/ventas/formulario/:id" element={
            <ProtectedRoute requirePermission="ventas">
              <Layout><SalesFormPage key="edit" /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/ventas/historial" element={
            <ProtectedRoute requirePermission="ventas">
              <Layout><SalesHistoryPage /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/ventas/resumen" element={
            <ProtectedRoute requirePermission="ventas">
              <ProtectedRoute requirePermission="sales_summary">
                <Layout><SalesSummaryPage /></Layout>
              </ProtectedRoute>
            </ProtectedRoute>
          } />

          <Route path="/despachos" element={
            <ProtectedRoute requirePermission="despachos">
              <Layout><DespachosPage /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/despachos/remision" element={
            <ProtectedRoute requirePermission="despachos">
              <Layout><RemisionFormPage key="new" /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/despachos/remision/:id" element={
            <ProtectedRoute requirePermission="despachos">
              <Layout><RemisionFormPage key="edit" /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/despachos/historial" element={
            <ProtectedRoute requirePermission="despachos">
              <Layout><RemisionHistoryPage /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/users" element={
            <ProtectedRoute requirePermission="admin_users">
              <Layout><UsersPage /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/novedades" element={
            <ProtectedRoute requirePermission="novedades">
              <Layout><NovedadesPage /></Layout>
            </ProtectedRoute>
          } />

          <Route path="/profile" element={
            <ProtectedRoute>
              <Layout><ProfilePage /></Layout>
            </ProtectedRoute>
          } />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
